module.exports = __webpack_public_path__ + "img/ic_nolist.b285e90b.png";